var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlikelyfitBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14881_28214)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14881_28214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 14.125L14.8008 20.875M14.8008 14.125L21.5508 20.875",
    stroke: "#FB233A",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1758 26.875C23.3535 26.875 27.5508 22.6777 27.5508 17.5C27.5508 12.3223 23.3535 8.125 18.1758 8.125C12.9981 8.125 8.80078 12.3223 8.80078 17.5C8.80078 22.6777 12.9981 26.875 18.1758 26.875Z",
    stroke: "#FB233A",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14881_28214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0703,
    height: 24.0703,
    fill: "white",
    transform: "translate(6.14062 5.82031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14881_28214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.17578 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikelyfitBadgeIcon);
export default __webpack_public_path__ + "static/media/Unlikelyfit-badge-icon.312765adf2b36866b1528088d33035f7.svg";
export { ForwardRef as ReactComponent };